import { css } from '@emotion/css';
import { m } from '@snapchat/snap-design-system-marketing';

export const errorTextCss = css`
  color: ${m('--form-input-error-color')};
  margin: ${m('--spacing-xs')};
`;
